import { createInstance, OptimizelyDecideOption } from "@optimizely/optimizely-sdk";
export class Project {
    instance;
    constructor(instance) {
        this.instance = instance;
    }
    static async initialize(params) {
        let instance;
        if (params.datafile) {
            instance = createInstance({
                datafile: params.datafile,
            });
        }
        else {
            instance = createInstance({
                sdkKey: params.sdkKey,
                ...(params.options && {
                    datafileOptions: {
                        autoUpdate: params.options.autoUpdate,
                        updateInterval: params.options.updateInterval,
                    }
                })
            });
        }
        if (!instance)
            throw new Error("Failed to create instance");
        // Wait for the datafile to be ready before returning the Project
        const result = await instance.onReady();
        if (!result.success) {
            throw new Error(`Failed to initialize Optimizely: ${result.reason}`);
        }
        return new Project(instance);
    }
    async decision(flagKey, userId, variationOverride, sendImpression = true) {
        const userContext = await this.getUserContext(userId);
        // Set forced decision if variation override is provided
        if (variationOverride) {
            const decisionContext = this.getDecisionContext(flagKey);
            const forcedDecision = this.getForcedDecision(variationOverride);
            userContext.setForcedDecision(decisionContext, forcedDecision);
        }
        // Disable decision event if variation is forced or sendImpression is false
        const decisionOptions = [];
        if (variationOverride || !sendImpression) {
            decisionOptions.push(OptimizelyDecideOption.DISABLE_DECISION_EVENT);
        }
        return userContext.decide(flagKey, decisionOptions);
    }
    async trackEvent(eventKey, userId, variationOverride) {
        // Don't track events if decision is forced
        if (variationOverride)
            return;
        const userContext = await this.getUserContext(userId);
        userContext.trackEvent(eventKey);
    }
    async close() {
        await this.instance.close();
    }
    getOptimizelyProject() {
        return this.instance;
    }
    // private
    async getUserContext(userId) {
        const userContext = this.instance.createUserContext(userId);
        if (!userContext)
            throw new Error("Failed to create user context");
        return userContext;
    }
    getDecisionContext(flagKey) {
        return { flagKey };
    }
    getForcedDecision(variationOverride) {
        return { variationKey: variationOverride };
    }
}
